export enum DataControlType {
  DEDICATED_DATA = 'DEDICATED_DATA',
  GENERAL_DATA = 'GENERAL_DATA',
  LOW_SPEED_DATA = 'LOW_SPEED_DATA',
}
